import React, { useCallback, useState } from "react";
import SelectBox from "../../components/SelectBox";
import useAppContext from "../../utils/Reducers";
import moment from "moment";

const SearchBar = (props) => {
  // SerachBar 기본 필드

  const {
    store: { userInfo },
  } = useAppContext();

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;
    //console.log("name === " + name + " || value === " + value);

    props.setSearchParameters({ ...props.searchParameters, [name]: value });
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li className="date">
            <div className="divide40">
              <font color="grey">⦁</font> 입고일자
            </div>
            <div className="flex50">
              <input
                type="date"
                name="schSwghtDt"
                id="schSwghtDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.searchParameters.schSwghtDt}
              />
              &nbsp;~&nbsp;
              <input
                type="date"
                name="schEwghtDt"
                id="schEwghtDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.searchParameters.schEwghtDt}
              />
            </div>
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 사업장구분
            </div>
            <SelectBox
              mastCd="PLANT_CD"
              id="schPlantCd"
              name="schPlantCd"
              attr5="Y"
              topSelected="전체"
              onChange={handleChangeField}
              value={props.searchParameters.schPlantCd}
              className="datainput"
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 운송상태
            </div>
            <SelectBox
              mastCd="TRANS_STATUS_CD"
              name="schTransStatusCd"
              topSelected="전체"
              onChange={handleChangeField}
              className="datainput"
              value={props.searchParameters.schTransStatusCd}
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 배차구분
            </div>
            <select
              name="schOdrType"
              id="schOdrType"
              onChange={handleChangeField}
              className="datainput"
              value={props.searchParameters.schOdrType}
            >
              <option value="">전체</option>
              <option value="10">국내고철</option>
              <option value="30">국내바지선</option>
            </select>
          </li>
          <li style={{ width: "150px" }}>
            <input
              type="text"
              name="schSearch"
              id="schSearch"
              onChange={handleChangeField}
              className="datainput"
              value={props.searchParameters.schSearch}
              placeholder="검색어"
              style={{ width: "150px" }}
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
